import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    this.itemTargets.forEach((item) => {
      const name = item.dataset.name || ""
      const match = query === "" || name.includes(query)
      item.classList.toggle("hidden", !match)
    })
  }
}
